import VanCardu from './index.vue';

export {
    VanCardu,
};

export default VanCardu;
